import { render, staticRenderFns } from "./billing_record.vue?vue&type=template&id=45f25236&scoped=true"
import script from "./billing_record.vue?vue&type=script&lang=js"
export * from "./billing_record.vue?vue&type=script&lang=js"
import style0 from "./billing_record.vue?vue&type=style&index=0&id=45f25236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f25236",
  null
  
)

export default component.exports